import React from "react";
import { Form, Input, Select, Button, Space, Row, Col } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import { SERVICE_TYPE_OPTIONS } from "../../SupplierContract/constants";

const { Option } = Select;

const ProductBundleFilter = ({ onSearch, onReset }) => {
    const [form] = Form.useForm();

    // 处理搜索
    const handleSearch = () => {
        const values = form.getFieldsValue();
        // 清理空值
        const filteredValues = Object.fromEntries(
            Object.entries(values).filter(([_, value]) => value !== undefined && value !== null && value !== "")
        );
        onSearch(filteredValues);
    };

    // 处理重置
    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    // 处理回车搜索
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    return (
        <Form form={form} layout="inline" className="filter-form">
            <Row gutter={[16, 16]} style={{ width: "100%" }}>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="name" label="产品套装名称">
                        <Input
                            placeholder="搜索产品套装名称或编码"
                            allowClear
                            onKeyPress={handleKeyPress}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="service_type" label="服务类型">
                        <Select placeholder="选择服务类型" allowClear options={SERVICE_TYPE_OPTIONS} />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="is_active" label="状态">
                        <Select placeholder="选择状态" allowClear>
                            <Option value={true}>启用</Option>
                            <Option value={false}>停用</Option>
                        </Select>
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item>
                        <Space>
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>
                                搜索
                            </Button>
                            <Button icon={<ReloadOutlined />} onClick={handleReset}>
                                重置
                            </Button>
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default ProductBundleFilter; 